const removeTrailingSlashes = (value = "") => value.replace(/\/+$/, "");

const normalizeGestorApiUrl = (value) => {
  const defaultGestorApiUrl = "https://gestor.arrobamedellin.edu.co/api/v1";
  const normalizedUrl = removeTrailingSlashes(value || defaultGestorApiUrl);

  return normalizedUrl
    .replace(/\/api\/v(\d+)\/api(?=\/|$)/i, "/api/v$1")
    .replace(/\/api\/api(?=\/|$)/i, "/api");
};

const configService = {
  apiUrl: process.env.VUE_APP_URL_API_PHP + "/api",
  apiNodeUrl: process.env.VUE_APP_URLAPI,
  apiJitsi: process.env.VUE_APP_MEET,
  apiSocket: process.env.VUE_APP_SOCKET,
  apiGestorUrl: normalizeGestorApiUrl(process.env.VUE_APP_URL_GESTOR_API),
  livekitUrl:
    process.env.VUE_APP_LIVEKIT_URL || "wss://meet.arrobamedellin.edu.co",
};

export default configService;
